import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class STService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createSt = async (payload) => {
    const addedProduct = await Helpers.post({
      url: Constants.ST,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateSt = async (payload) => {
    const st = await Helpers.put({
      url: Constants.ST,
      data: payload,
    });
    return st;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updateStStatus = async (payload) => {
    const addedProduct = await Helpers.put({
      url: Constants.ST_STATUS,
      data: payload,
    });
    return addedProduct;
  }

  createStShortClose = async (payload) => {
    const createShortClose = await Helpers.post({
      url: Constants.ST_SHORT_CLOSE,
      data: payload,
    });
    return createShortClose;
  }

  /**
   * @param {*} page
   * @param {*} tenantId
   * @param stId
   * @param limit
   * @param searchKeyword
   * @param callback
   * @return
   */
  getSt = async (tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department) => {
    let url = `${Constants.ST}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (stId) url += `stock_transfer_id=${stId}&`;
    if (receivingStatus) url += `&stock_receiving_status=${receivingStatus}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (status) url += `status=${status}&`;
    if (department) url += `department_id=${department}&`;
    const st = await Helpers.get({
      url: `${url}`,
    });
    return st;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
   deleteSt = async (payload) => {
     const deleteSt = await Helpers.delete({
       url: Constants.ST,
       data: payload,
     });
     return deleteSt;
   }

   updateSTWorkflowStep = async (payload) => {
     const workflowStep = await Helpers.post({
       url: `${Constants.ST}/work_flow`,
       data: payload,
     });
     return workflowStep;
   }
}

export default new STService();
